@if (!isInModalContext) {

  <ng-container *sbPageAction>

    <a [pathParams]="[{ id: 'campaignID', value: campaignId }]" [sbRouterLink]="util.RoutingID.commercials">
      <sb-button classes="btn-default btn-sm text-uppercase">{{ "lang.globals.back" | translate }}</sb-button>
    </a>
  </ng-container>

  <sb-comp-ccr-hero [ccr]="campaign" [isCollapsed]="true"></sb-comp-ccr-hero>
  <sb-comp-ccr-hero [ccr]="commercial"></sb-comp-ccr-hero>
}

<div class="row" *ngIf="!exportState">
  <div class="col-12">
    <sb-card
      *ngIf="requirements?.length > 1 || cullCheck() || loading || !requirements || requirements?.length === 0"
      [loadingDelay]="1"
      [loading]="loading"
    >
      <div card-header>
        <h3>
          <sb-icon [dualColor]="true" class="mr-2" icon="crossway"></sb-icon>
          {{ "lang.requirementsList.requirements" | translate }}
        </h3>
      </div>
      <div card-header-more>
        <div class="tw-flex tw-flex-row tw-gap-3">
          <sb-comp-dropdown-select
            *ngPermissions="permissionService.Permission.cull_list"
            [singleSelectMode]="false"
            [inputData]="contentCulls" [dropDownDatatype]="'CONTENT_CULLS'"
            (selectedDataEmitter)="update($event, 'CONTENT_CULLS')" [showColumnIcon]="false"
            [msOptions]="msContentCullOptions" (msOptionsChange)="msRequest('CONTENT_CULLS', $event)"
            [selectedInputData]="selectedContentCulls ? selectedContentCulls : []">
          </sb-comp-dropdown-select>
          <button class="btn btn-primary" *ngIf="!isInModalContext" (click)="selectionForExport()">
            <sb-icon icon="download"></sb-icon>
            {{ "lang.globals.export" | translate }}
          </button>
          <a
            *ngIf="!isInModalContext"
            [pathParams]="[
                        { id: 'campaignID', value: campaignId },
                        { id: 'commercialID', value: commercialId }
                    ]"
            [sbRouterLink]="util.RoutingID.requirementCreate"
          >
            <sb-button classes="btn-success">
              <sb-icon class="mr-1" icon="plus"></sb-icon>
              {{ "lang.globals.addRequirement" | translate }}
            </sb-button
            >
          </a>
        </div>

      </div>
      <div card-fit>
        <ng-container *ngIf="loading">
          <sb-ghost-list [ghosts]="ghosts"></sb-ghost-list>
        </ng-container>
        <div>
          <div
            *ngIf="!requirements || requirements?.length === 0"
            class="tw-flex tw-justify-center tw-items-center tw-h-20">
            <span class="tw-italic tw-opacity-50">{{ "lang.bookingStatus.noRequirements" | translate }}</span>
          </div>
          <table *ngIf="requirements?.length > 1 || cullCheck() || loading" class="table">
            <thead>
            <tr>
              <th
                *ngIf="
                                        (discussionService.showRibbon || discussionService.showDiscussionSideBar) &&
                                        !isInModalContext
                                    "
                class="sticky-col first-col tableBg"
              ></th>
              <th>{{ "lang.globals.level" | translate }}</th>
              <th>{{ "lang.requirementsList.requirement" | translate }}</th>
              <th>{{ "lang.globals.verification" | translate }}</th>
              <th *ngPermissions="permissionService.Permission.ds_cm_reporting">
                {{ "lang.globals.playoutPulse" | translate }}
              </th>

              <th>{{ 'lang.globals.playouts' | translate }}</th>
              <th>{{ "lang.globals.filter" | translate }}</th>
              <th>{{ "lang.globals.locationsScreens" | translate }}</th>
              <th>{{ "lang.globals.modifiedAt" | translate }}</th>
              <th class="text-right"></th>
            </tr>
            </thead>
            <tbody>
            <tr
              *ngFor="let requirement of requirements; index as i; last as last"
              [ngClass]="{ 'tw-opacity-50': !requirement.active }"
            >
              <td
                *ngIf="
                                        (discussionService.showRibbon || discussionService.showDiscussionSideBar) &&
                                        !isInModalContext
                                    "
                [entityElement]="{
                                        type: discussionService.DISCUSSABLES.Requirement,
                                        element: requirement
                                    }"
                [inTable]="true"
                [inline]="true"
                class="sticky-col first-col tableBg"
                sb-discussion
              ></td>
              <td>
                {{ requirement.level }}
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <sb-action-required
                    [bookingStatus]="requirement.bookingStatus"
                    class="mr-4"
                  ></sb-action-required>
                  <sb-comp-image-name-wrapper [medium]="requirement?.previewMedia" [still]="true">
                    <sb-comp-link
                      [link]="util.RoutingID.requirementEdit"
                      [pathParams]="[
                        { id: 'campaignID', value: campaign?.id },
                        { id: 'commercialID', value: commercial?.id },
                        { id: 'requirementID', value: requirement?.id }
                      ]"
                      [permission]="permissionService.Permission.campaign_edit"
                      [title]="requirement?.name"
                      [tooltip]="'lang.globals.editRequirement' | translate"
                      firstLine
                    >
                    </sb-comp-link>
                    <span *ngIf="requirement?.mediumGroups?.length > 0" secondLine>
                                                {{ requirement?.mediumGroups.length }}
                      {{
                        requirement?.mediumGroups?.length === 1
                          ? ("lang.globals.mediumGroup" | translate)
                          : ("lang.globals.mediumGroups" | translate)
                      }}
                                            </span>
                    <span thirdLine [innerHTML]="requirement?.identifier | truncate:30"></span>
                    <span fourthLine [innerHTML]="requirement?.description | truncate:30"></span>
                    <sb-tags
                      *ngPermissions="[permissionService.Permission.tag_list]"
                      [dtoId]="requirement.id"
                      [dtoType]="tagService.TaggableDTO.Requirement"
                      [tags]="requirement.tags"
                      fifthLine
                    >
                    </sb-tags>
                  </sb-comp-image-name-wrapper>
                </div>
              </td>
              <td style="width: 118px">
                <sb-verification-progress
                  [bookingStatus]="requirement.bookingStatus"
                ></sb-verification-progress>
              </td>
              <td *ngPermissions="permissionService.Permission.ds_cm_reporting" style="width: 180px">
                <sb-line-small-chart
                  *ngIf="requirement?.reporting?.loadingDone"
                  [chartData]="requirement.reporting"
                ></sb-line-small-chart>
              </td>
              <td>
                <sb-comp-playout-aggregation [playoutAggregation]="requirement?.playoutAggregation"></sb-comp-playout-aggregation>
              </td>
              <td>
                <sb-comp-filter-overview
                  [geoCull]="requirement?.geoCull"
                  [playerCull]="requirement?.playerCull"
                  [stateSpaceCull]="requirement?.stateSpaceCull"
                  [timeCull]="requirement?.timeCull"
                >
                </sb-comp-filter-overview>
              </td>
              <td>
                <div class="filter">
                  <div class="filter__sum">
                    <div class="filter__sum__item">
                      <sb-icon icon="location"></sb-icon>
                      {{ requirement?.playerAggregation?.locations | sbNumberFormat }}
                    </div>
                    /
                    <div class="filter__sum__item">
                      <sb-icon [icon]="'screen'"></sb-icon>
                      {{ requirement?.playerAggregation?.screens | sbNumberFormat }}
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <sb-comp-display-modified [data]="requirement"></sb-comp-display-modified>
              </td>
              <td class="text-right sticky-col last-col tableBg">
                <sb-table-buttons>
                  <ng-container *ngIf="!isInModalContext">
                    <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                      <a
                        [pathParams]="[
                                                        { id: 'campaignID', value: campaign?.id },
                                                        { id: 'commercialID', value: commercial?.id },
                                                        { id: 'requirementID', value: requirement?.id }
                                                    ]"
                        [sbRouterLink]="util.RoutingID.requirementEdit"
                        class="btn-secondary btn"
                        container="body"
                        ngbTooltip="{{ 'lang.globals.editRequirement' | translate }}"
                      >
                        <sb-icon [icon]="'edit'"></sb-icon>
                      </a>
                    </ng-container>
                    <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                      <a
                        [pathParams]="[{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercial?.id},{ id: 'requirementID', value: requirement?.id }]"
                        [queryParams]="{ returnTo: this.util?.getPageLink(), skipToBooking: true}"
                        [sbRouterLink]="util.RoutingID.requirementEdit"
                        class="btn-default btn"
                        container="body"
                        ngbTooltip="{{'lang.globals.bookings' | translate}}">
                        <sb-icon icon="bookings"></sb-icon>
                      </a>
                    </ng-container>
                    <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                      <a class="btn-info btn"
                         (click)="copyRequirementModal(requirement)"
                         container="body"
                         ngbTooltip="{{'lang.globals.copyRequirement' | translate}}">
                        <sb-icon icon="copy"></sb-icon>
                      </a>
                    </ng-container>
                    <ng-container *ngPermissions="permissionService.Permission.campaign_delete">
                      <a
                        (click)="deleteRequirement(requirement)"
                        class="btn btn-danger"
                        container="body"
                        ngbTooltip="{{ 'lang.globals.deleteRequirement' | translate }}"
                      >
                        <sb-icon [icon]="'trash'"></sb-icon>
                      </a>
                    </ng-container>
                    <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                      <button
                        (click)="toggleRequirementEnabled(requirement, !requirement.active)"
                        (mouseenter)="requirement.isHover = true"
                        (mouseleave)="requirement.isHover = false"
                        [ngClass]="requirement.active ? 'btn-success' : 'btn-warning'"
                        class="btn btn-info ml-2"
                        style="
                                                        width: calc(1.35em + 1.1rem + 7px);
                                                        padding: 0 !important;
                                                        height: calc(1.35em + 1.1rem + 5px);
                                                    "
                      >
                        <sb-icon
                          *ngIf="requirement.active"
                          [hover]="requirement.isHover"
                          [icon]="'playToPauseAnimation'"
                        ></sb-icon>
                        <sb-icon
                          *ngIf="!requirement.active"
                          [hover]="requirement.isHover"
                          [icon]="'pauseToPlayAnimation'"
                        ></sb-icon>
                      </button>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="isInModalContext">
                    <a
                      (click)="selectRequirement(requirement)"
                      class="btn btn-hover-primary"
                      container="body"
                      ngbTooltip="{{ 'lang.globals.select' | translate }}"
                    >
                      <sb-icon
                        *ngIf="
                                                        util.arrayToIdArray(selectedRequirements) &&
                                                        util
                                                            .arrayToIdArray(selectedRequirements)
                                                            ?.indexOf(requirement.id) !== -1
                                                    "
                        [icon]="'boxChecked'"
                      ></sb-icon>
                      <sb-icon
                        *ngIf="
                                                        !util.arrayToIdArray(selectedRequirements) ||
                                                        util
                                                            .arrayToIdArray(selectedRequirements)
                                                            ?.indexOf(requirement.id) === -1
                                                    "
                        [icon]="'box'"
                      ></sb-icon>
                    </a>
                  </ng-container>
                </sb-table-buttons>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isInModalContext" card-footer>
        <div class="row">
          <div class="col-8">
            <div class="row" style="height: 100%; display: flex; align-items: center">
              <div *ngFor="let e of selectedRequirements" class="col-3">
                <a
                  [innerHTML]="e.name | truncate: 25"
                  class="font-weight-bold link mr-2"
                  style="white-space: nowrap; height: 30px"
                ></a>
              </div>
            </div>
          </div>
          <div class="col-4 justify-content-end d-flex align-items-center">
                        <span class="mr-2 font-weight-bold text-dark"
                        >{{ selectedRequirements?.length }} {{ "lang.globals.selected" | translate }}</span
                        >
            <button
              (click)="deselectRequirements()"
              [disabled]="selectedRequirements?.length < 1"
              class="btn btn-danger btn-sm mr-1"
            >
              {{ "lang.globals.deselectAll" | translate }}
            </button>
            <button (click)="returnSelectedRequirements()" [disabled]="selectedRequirements?.length < 1"

                    class="btn btn-primary btn-sm">
              {{ "lang.globals.save" | translate }}

            </button>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>


<div *ngIf="exportState">
  <form [formGroup]="form" class="wizard__forms pr-5 pl-5">
    <div class="row">
      <div class="col">
        <div class="form-group validateMe">
          <label class="form-label" for="Title">{{ 'lang.globals.title' | translate }}</label>
          <input type="text" id="Title" class="form-control" formControlName="Title"
                 sbAutofocus>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <sb-local-date-time-input
            [title]="translate.instant('lang.globals.startTime')" [seconds]="false"
            [kind]="'RANGE_START'"
            (modelChange)="localDateTimeInputFrom($event)">
          </sb-local-date-time-input>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <sb-local-date-time-input
            [title]="translate.instant('lang.globals.dueTime')" [seconds]="false"
            [kind]="'RANGE_END'"
            [minDate]="reportFrom"
            (modelChange)="localDateTimeInputTill($event)"></sb-local-date-time-input>
        </div>
      </div>
    </div>
    <div class="wizard__footerActions mb-3 d-flex justify-content-end">
      <button (click)="returnSelectedRequirements()" class="btn btn-primary btn-sm">
        {{ 'lang.globals.save' | translate }}
      </button>
    </div>
  </form>
</div>
